import { render, staticRenderFns } from "./TestRunnerDashboardSummary.vue?vue&type=template&id=245ccc26&scoped=true"
import script from "./TestRunnerDashboardSummary.vue?vue&type=script&lang=js"
export * from "./TestRunnerDashboardSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ccc26",
  null
  
)

export default component.exports